<template>
  <div class="custom-checklist dbox">
    <div class="dt-list">
      <div class="dt-list-item" v-for="comment of comments" :key="comment.comment_id">
        <div class="dt-list-item--body">
          <div class="dt-list-item--text">{{comment.comment}}</div>
        </div>
        <div class="dt-list-item--options">
          <div class="dt-list-item--icon">
            <div class="dt-icon-container" @click="onCommentDelete(comment.comment_id)">
              <img src="static/icons/delete.svg" class="dt-icon" alt>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dbox-title-bar--options">
      <img 
        @click="openAddModal" 
        src="static/icons/add-icon.svg" 
        class="dt-icon v4"
      >
      <!-- <div class="button add-button">
        <div class="dt-icon-container">
          <img @click="openAddModal" src="static/icons/add.svg" class="dt-icon" alt>
        </div>
      </div> -->
    </div>

    <v-dialog v-model="addCommentModal" persistent width="600">
      <AddNew @added="onCommentAdded" @cancelled="onAddCommentCancelled"/>
    </v-dialog>
  </div>
</template>

<script>
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace
} from "../../../store";
import * as ActionTypes from "../../../store/types";
import { mapGetters, mapActions } from "vuex";

import { bookingPromotersService as BPS } from "../../../services/booking-promoters.service";
import { ConfirmationService } from "../../../../../dt-plugins/confirmation/confirmation.service";
import AddNew from "./public-comments-add";
import { throwError } from "rxjs";

export default {
  props: ["promoterOverview"],
  components: {
    AddNew
  },
  data: function() {
    return {
      comments: [],
      addCommentModal: false
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      modal: "routeQueryModal"
    })
  },
  methods: {
    // ...mapActions(storeNS, {}),
    openAddModal: function() {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_promoter_comment" }
      });
    },
    onCommentDelete(commentID) {
      ConfirmationService.create({
        subject: "Do you really want to delete this Comment ?",
        model: true,
        width: 500,
        completed: res => {
          switch (res) {
            case "OK":
              let itemsAfterDeleted = this.comments.filter(
                row => row.comment_id != commentID
              );
              this.comments = itemsAfterDeleted;

              let promoterOverview = this.promoterOverview;
              promoterOverview.public_comments = this.comments;
              this.$emit("setChanges", "overview", promoterOverview);

              BPS.deletePromoterComment(commentID);

              break;
            default: {
            }
          }
        }
      });
    },

    onCommentAdded(comment) {
      BPS.addPromoterComment(this.promoterOverview.promoter_id, comment).then(
        res => {
          BPS.getPromoterComment(this.promoterOverview.promoter_id).then(
            resComm => {
              this.comments = resComm.data.public_comments;
              let promoterOverview = this.promoterOverview;
              promoterOverview.public_comments = this.comments;
              this.$emit("setChanges", "overview", promoterOverview);
              this.onAddCommentCancelled();
            }
          );
        }
      );
    },

    onAddCommentCancelled() {
      this.$router.replace({ query: null });
    }
  },
  watch: {
    promoterOverview: function(n, o) {
      this.comments = n.public_comments;
    },
    $route: {
      immediate: true,
      handler: function(to, from) {
        this.addCommentModal = to.query.modal === "add_promoter_comment";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dt-list {
  .dt-list-item {
    padding: 5px 10px;
    font-size: 13px;
    color: var(--icolr-1);

    display: flex;

    &:not(:last-child) {
      border-bottom: 1px solid var(--sprt-10);
    }

    &--body {
      flex: 1;
    }
    &--options {
      max-width: 10px;
    }
  }
}
</style>
